<template>
  <a-card :title="title" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
          :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="currentFormLayout2.labelCol"
      :wrapper-col="currentFormLayout2.wrapperCol"
    >
      <a-form-model-item prop="pointRuleName" label="积分规则名称">
        <a-input v-model="ruleForm.pointRuleName" :disabled="ruleForm.isPreset==1" allowClear :maxLength="10"
                 placeholder="请输入" style="max-width: 500px;"/>
      </a-form-model-item>
      <a-form-model-item label="参与周期" prop="partakeCycle">
        <a-select v-model="ruleForm.partakeCycle" placeholder="请选择" style="max-width: 500px;"
                  :disabled="ruleForm.isPreset==1">
          <a-select-option v-for="(item,index) in typeList" :value="item.key" :key="item.key">{{ item.value }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="可获积分" prop="availablePoint" v-if="ruleForm.isPreset!=1">
        <a-input-number v-model="ruleForm.availablePoint" placeholder="请输入" :min="1" :max="100000000"
                        style="width: 150px;"/>
      </a-form-model-item>
      <a-form-model-item label="类型" prop="ruleType">
        <a-select v-model="ruleForm.ruleType" placeholder="请选择" style="max-width: 500px;"
                  :disabled="ruleForm.isPreset==1">
          <a-select-option v-for="(item,index) in dataList" :value="item.key" :key="item.key"
                           :disabled="item.key==1&&ruleForm.isPreset!=1">{{ item.value }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="指定商品分组" prop="productGroup" v-if="ruleForm.ruleType==2||ruleForm.ruleType==3">
        <a-button @click='showSelectedGroupDialog = true'>选择</a-button>
        <span v-if="ruleForm.productGroup"> 商品分组ID:{{ ruleForm.productGroup }}</span>
      </a-form-model-item>
      <a-form-model-item label="指定商品" prop="productId" v-if="ruleForm.ruleType==4">
        <a-button @click="visiblePopup = true">选择</a-button>
        <span v-if="ruleForm.productId"> 商品ID:{{ ruleForm.productId }}</span>
      </a-form-model-item>
      <a-form-model-item v-if="ruleForm.ruleType==5" label="指定搜索词" prop="searchKeyword">
        <a-input v-model="ruleForm.searchKeyword" allowClear :maxLength="20" placeholder="请输入"
                 style="max-width: 500px;"/>
      </a-form-model-item>
      <div v-if="ruleForm.ruleType==1">
        <a-form-model-item label="是否开启打卡任务">
          <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.isEnableSignTask"/>
        </a-form-model-item>
        <a-form-model-item prop="availablePoint" label="每日签到可得">
          <a-input v-model="ruleForm.availablePoint" allowClear :maxLength="15" addon-after="积分" placeholder="请输入"
                   style="max-width: 500px;"/>
        </a-form-model-item>
        <a-form-model-item v-for="(item, index) in ruleForm.continueSignRuleList" :key="index" label="连续签到第"
                           style="margin-bottom: 0">
          <a-form-model-item :prop="'continueSignRuleList.' + index + '.days'"
                             :rules="[
                               { required: true, message: '请输入',  trigger: 'blur', },
                               { pattern: /^[0-9]\d*$/, message: '必须是正整数', trigger: 'blur' }
                             ]"
                             style="display: inline-block">
            <a-input v-model="item.days" placeholder="请输入" style="width: 210px; margin-right: 8px"/>
          </a-form-model-item>
          <span>天，可得 </span>
          <a-form-model-item :prop="'continueSignRuleList.' + index + '.points'"
                             :rules="[
                               { required: true, message: '请输入',  trigger: 'blur', },
                               { pattern: /^[1-9][0-9]?$/, message: '必须1-99的正整数', trigger: 'blur' }
                             ]"
                             style="display: inline-block">
            <a-input v-model="item.points" placeholder="请输入" addon-after="积分"
                     style="width: 200px; margin-right: 8px"/>
          </a-form-model-item>
          <a-icon v-if="ruleForm.continueSignRuleList.length > 1" class="dynamic-delete-button" type="minus-circle-o"
                  :disabled="ruleForm.continueSignRuleList.length === 1" @click="removeDomain(item)"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
          <a-button type="dashed" style="width: 500px;" @click="addDomain">
            <a-icon type="plus"/>
            添加
          </a-button>
        </a-form-model-item>
        <a-form-model-item label="签到规则说明" prop="signRuleDesc">
          <a-textarea v-model="ruleForm.signRuleDesc" placeholder="请输入" style="max-width: 500px;"
                      :auto-size="{ minRows: 4, maxRows: 10 }"/>
        </a-form-model-item>
      </div>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</a-button>
        <a-button @click="backEvent" style="margin-left: 15px;">取消</a-button>
      </a-form-model-item>
    </a-form-model>

    <!-- 商品组件弹窗 -->
    <ProductPopupView :visible="visiblePopup" @change="changeSelectPro" @cancel="handleCancel"></ProductPopupView>
    <selected-product-dialog
      ref="groupDialog"
      :col="2"
      title="选择商品分组"
      :show="showSelectedGroupDialog"
      :itemNames="['search_proName']"
      :query-params="selectedQueryGroupParams"
      :request-promise="getGroupRequest"
      @close="showSelectedGroupDialog=false"
      :columns="getGroupColumns()"
    >
      <a-form-item
        label="商品分组名称"
        slot="search_proName"
        :wrapperCol="{span:18}"
        :labelCol="{span:6}">
        <a-input v-model="selectedQueryGroupParams.groupName" style="width: 100%"
                 placeholder="请输入商品分组名称"></a-input>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedGroupResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import ruleFormLayout from '@/utils/mixins/ruleFormMixins'
import ProductPopupView from '@/customComponents/productPopupView/productPopupView'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'NewIntegralRule',
  mixins: [ruleFormLayout],
  components: {
    ProductPopupView,
    SelectedProductDialog
  },
  data() {
    return {
      submitLoading: false,
      title: '',
      id: 0,
      ruleForm: {
        availablePoint: '',//可获积分
        isPreset: 0,//1 预设 0 非预设
        partakeCycle: undefined,//参与周期 1=1次/日、2=不限次
        pointRuleName: '',// 积分规则名称
        productGroup: undefined,//指定商品分组ID（rule_type=2、3时使用）
        productId: undefined,//指定商品ID（rule_type=4时使用）
        ruleType: undefined,// 规则类型 1=签到、2=下单、3=浏览商品、4=转发海报、5=搜索 ,
        searchKeyword: '',//指定搜索词（rule_type=5时使用）
        signRuleDesc: '',//签到规则说明（rule_type=1时使用）
        continueSignRuleList: []
      },
      rules: {
        pointRuleName: [
          { required: true, message: '请输入积分规则名称', trigger: 'blur' }
        ],
        partakeCycle: [
          { required: true, message: '请选择参与周期', trigger: 'change' }
        ],
        availablePoint: [
          { required: true, message: '请输入积分', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '必须是正整数', trigger: 'blur' }
        ],
        ruleType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        searchKeyword: [
          { required: true, message: '请输入指定搜索词', trigger: 'blur' }
        ],
        signRuleDesc: [
          { required: true, message: '请输入签到规则说明', trigger: 'blur' }
        ],
        productGroup: [
          { required: true, message: '请选择商品分组', trigger: ['blur', 'change'] }
        ],
        productId: [
          { required: true, message: '请选择商品ID', trigger: ['blur', 'change'] }
        ]
      },
      visiblePopup: false,
      showSelectedGroupDialog: false,
      selectedQueryGroupParams: { groupStatus: 1, groupName: '' },
      dataList: [],
      typeList: []
    }
  },
  created() {
    this.id = this.getPageParams().id
    this.title = this.id != 0 ? '编辑积分规则' : '新建积分规则'
    this.getPointRuleTypeEnum()
    this.getPointRulePartakeCycleEnum()
    this.getRuleDataDetail()
  },
  mounted() {
  },
  methods: {
    getPointRuleTypeEnum() {
      this.getHttpServices().getIntegralApiService().post('admin/pointsRule/getPointRuleTypeEnum').then(res => {
        this.getLogUtils().logWithTag('枚举', res)
        this.dataList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getPointRulePartakeCycleEnum() {
      this.getHttpServices().getIntegralApiService().post('admin/pointsRule/getPointRulePartakeCycleEnum').then(res => {
        this.getLogUtils().logWithTag('枚举', res)
        this.typeList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getRuleDataDetail() {
      if (this.id && this.id != 0) {
        this.getHttpServices().getIntegralApiService().post('admin/pointsRule/detail/' + this.id).then(res => {
          this.getLogUtils().logWithTag('getRuleDataDetail', res)
          this.ruleForm = { ...res }
          if (res.isPreset == 1) {
            this.ruleForm.isEnableSignTask = res.isEnableSignTask == 1 ? true : false
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    },
    // 选择商品
    changeSelectPro(item) {
      this.getLogUtils().logWithTag('选择商品', item)
      this.ruleForm.productId = item.proId
      this.handleCancel()
      this.$refs.ruleForm.validateField('productId', (Error) => {
      })
    },
    handleCancel() {
      this.visiblePopup = false
    },
    removeDomain(item) {
      let index = this.ruleForm.continueSignRuleList.indexOf(item)
      if (index !== -1) {
        this.ruleForm.continueSignRuleList.splice(index, 1)
      }
    },
    addDomain() {
      this.ruleForm.continueSignRuleList.push({
        days: '',
        points: ''
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      if (params.isPreset == 1) {
        params.isEnableSignTask = params.isEnableSignTask ? 1 : 0
      }
      //规则类型 1=签到、2=下单、3=浏览商品、4=转发海报、5=搜索 ,
      if (params.ruleType == 2 || params.ruleType == 3) {
        params.searchKeyword = ''
        params.productId = undefined
      } else if (params.ruleType == 4) {
        params.searchKeyword = ''
        params.productGroup = undefined
      } else {
        params.productId = undefined
        params.productGroup = undefined
      }
      this.getLogUtils().logWithTag('params', params)
      let path = this.id && this.id != 0 ? 'admin/pointsRule/update' : 'admin/pointsRule/add'
      this.getHttpServices().getIntegralApiService().post(path, params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        let textStr = this.id && this.id != 0 ? '编辑' : '新建'
        this.$message.success(textStr + '积分规则成功')
        setTimeout(() => {
          this.backEvent()
        }, 800)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    onSelectedGroupResult(record) {
      console.error('onSelectedGroupResult', record)
      this.ruleForm.productGroup = record.groupId
      this.showSelectedGroupDialog = false
      this.$refs.ruleForm.validateField('productGroup', (Error) => {
      })
    },
    getGroupRequest(params) {
      return this.getHttpServices().getProService().post('proGroup/findProGroupList', params)
    },
    getGroupColumns() {
      return [
        {
          title: 'id',
          dataIndex: 'groupId',
          width: '60px'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.tips {
  color: rgba(51, 51, 51, 0.45);
  height: 20px;
  line-height: 20px;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}
</style>